/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Bold_Whale_SurfInputs */

const en_keen_bold_whale_surf = /** @type {(inputs: Keen_Bold_Whale_SurfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Granting access to results...`)
};

const de_keen_bold_whale_surf = /** @type {(inputs: Keen_Bold_Whale_SurfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebniszugriff freigeben..`)
};

/**
* | output |
* | --- |
* | "Granting access to results..." |
*
* @param {Keen_Bold_Whale_SurfInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_bold_whale_surf = /** @type {((inputs?: Keen_Bold_Whale_SurfInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Bold_Whale_SurfInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_bold_whale_surf(inputs)
	return de_keen_bold_whale_surf(inputs)
});